import { Role } from '@/enum/global.enum'

/**
 * Converts role identifiers to human-readable display labels
 *
 * This utility function takes a role identifier (from the Role enum or string)
 * and returns a user-friendly display label that can be used in UI components
 * like badges, user cards, or role selection dropdowns.
 *
 * @param role - The role identifier to convert. Can be a Role enum value, string, null, or undefined
 * @returns A human-readable string representing the role. Returns 'xxxx' for unknown/null roles
 */
const roleLabel = (role?: Role | null | string) => {
  if (!role) return ''

  switch (role) {
    case Role.SUPER_ADMIN:
      return 'Super Admin'
    case Role.ADMIN:
      return 'Admin'
    case Role.ORG_ADMIN:
      return 'Admin'
    case Role.ORG_MANAGER:
      return 'Manager'
    case Role.ORG_ASSESSOR:
      return 'Assessor'
    case Role.ORG_VIEWER:
      return 'Viewer'
    case Role.ORG_AUDITOR:
      return 'Auditor'
    case Role.ORG_CONSULTANT:
      return 'Consultant'
    case Role.ORG_CISO:
      return 'CISO'
    case Role.ORG_COMPLIANCE_MANAGER:
      return 'Compliance Manager'
    case Role.ORG_RISK_MANAGER:
      return 'Risk Manager'
    case Role.ORG_POLICY_MANAGER:
      return 'Policy Manager'
    case Role.ORG_INTERNAL_AUDITOR:
      return 'Internal Auditor'
    case Role.ORG_EXTERNAL_AUDITOR:
      return 'External Auditor'
    case Role.ORG_LEAD_QSA:
      return 'Lead QSA'
    case Role.ORG_QSA_SUBCONTRACTOR:
      return 'QSA Subcontractor'
    case Role.ORG_USER:
      return 'User'
    case Role.VENDOR:
      return 'Vendor'
    case Role.VENDOR_COLLABORATOR:
      return 'Vendor Collaborator'
    default:
      return ''
  }
}

export { roleLabel }
